export default __webpack_public_path__ + "static/media/6.814cb005.png";